import config from 'constants/config'
import React from 'react'
import { useIntl } from 'react-intl'
import { getPlural } from 'lib/string/pluralize'

interface Props {
  points: number
  abbreviated?: boolean
}

function FormatLoyaltyBonusPoints({ points, abbreviated }: Props) {
  const intl = useIntl()
  const singular = abbreviated ? config.loyalty.bonusPointsUnitAbbreviation : config.loyalty.bonusPointsUnit
  return <>{intl.formatMessage(
    {
      id: 'RWHnyeLqJs0dtp6VG5-A',
      defaultMessage: '{count, plural, one {# {singular}} other {# {plural}}}',
      description: 'Loyalty bonus points count with dynamic unit from config',
    },
    { count: points, singular, plural: getPlural(singular) },
  )}
  </>
}

export default FormatLoyaltyBonusPoints
